module.exports = __webpack_public_path__ + "static/media/screenshot(3).53b3917b.jpg";